import posthog from "posthog-js";
import type { AuthUser } from "./types";

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;

export const isAnalyticsEnabled = Boolean(posthogKey);

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? "https://eu.i.posthog.com",
    ui_host: "https://eu.posthog.com",
    defaults: "2025-05-24",
    autocapture: true,
    person_profiles: "identified_only",
  });
}

export function identifyUser(user: AuthUser | null | undefined): void {
  if (!isAnalyticsEnabled || !user?.sub) {
    return;
  }

  posthog.identify(user.sub, {
    email: user.email,
    name: user.name,
    is_admin: user.isAdmin === true,
  });
}

export function resetAnalytics(): void {
  if (!isAnalyticsEnabled) {
    return;
  }

  posthog.reset();
}

export default posthog;
